import React from 'react';
import { INDIAN_STATES } from '../data/indianStates';
import { Dropdown } from './Dropdown';

export interface IndianStateSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
}

export const IndianStateSelect: React.FC<IndianStateSelectProps> = ({
  className = 'auth-select', // Match default of CountrySelect
  required,
  ...props
}) => {
  return (
    <Dropdown
      className={className}
      wrapperClassName="site-dropdown--full-width"
      required={required}
      {...props}
    >
      <option value="" disabled>
        Select State / Union Territory
      </option>
      {INDIAN_STATES.map((state: { code: string; label: string }) => (
        <option key={state.code} value={state.code}>
          {state.label}
        </option>
      ))}
    </Dropdown>
  );
};
